module.exports = __webpack_public_path__ + "static/media/support.a25fbf6c.png";